import { supabase } from '@/config/supabase'
import type { Tenant, UUID } from '@/types/database'

export const tenantService = {
    async list() {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_tenants')
            .select('*')
            .order('nome', { ascending: true })

        if (error) throw error
        return (data || []) as Tenant[]
    },

    async create(data: Partial<Tenant>) {
        // @ts-ignore
        const { data: res, error } = await supabase
            .schema('veicular_system')
            .from('veic_tenants')
            .insert({
                ...data,
                ativo: true,
                plano: 'pro',
                config: data.config || {}
            } as any)
            .select()
            .single()

        if (error) throw error
        return res as Tenant
    },

    async update(id: UUID, data: Partial<Tenant>) {
        // @ts-ignore
        const { data: res, error } = await supabase
            .schema('veicular_system')
            .from('veic_tenants')
            // @ts-ignore
            .update(data as any)
            .eq('id', id)
            .select()
            .single()

        if (error) throw error
        return res as Tenant
    },

    async toggleStatus(id: UUID, status: boolean) {
        // @ts-ignore
        const { error } = await supabase
            .schema('veicular_system')
            .from('veic_tenants')
            // @ts-ignore
            .update({ ativo: status } as any)
            .eq('id', id)

        if (error) throw error
    }
}
